export const NEUTRAL_SENTIMENT = 0;
export const POSITIVE_SENTIMENT = 1;
export const NEGATIVE_SENTIMENT = 2;

export const ALL_SENTIMENT_LABEL = 'All Data Points';
export const NEUTRAL_SENTIMENT_LABEL = 'Neutral';
export const NEGATIVE_SENTIMENT_LABEL = 'Negative';
export const POSITIVE_SENTIMENT_LABEL = 'Positive';

export const NO_SENTIMENT_COLOR = '#b222d7';

export const SENTIMENT_COLORS = {
    [NEGATIVE_SENTIMENT]: '#F65272',
    [POSITIVE_SENTIMENT]: '#70C48C',
    [NEUTRAL_SENTIMENT]: '#b4bbc6'
};

export const SENTIMENT_INDICATOR_COLORS = {
    [NEGATIVE_SENTIMENT]: '#f5222d',
    [POSITIVE_SENTIMENT]: '#52c41a',
    [NEUTRAL_SENTIMENT]: '#b4bbc6'
};

export const ALL_SENTIMENTS = [
    {
        label: NEUTRAL_SENTIMENT_LABEL,
        value: NEUTRAL_SENTIMENT
    },
    {
        label: POSITIVE_SENTIMENT_LABEL,
        value: POSITIVE_SENTIMENT
    },
    {
        label: NEGATIVE_SENTIMENT_LABEL,
        value: NEGATIVE_SENTIMENT
    }
];
